import React from 'react';

export default function WalletIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-wallet' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
